import { render, staticRenderFns } from "./CustomerNewPasswordForm.vue?vue&type=template&id=48b47482&"
import script from "./CustomerNewPasswordForm.vue?vue&type=script&lang=js&"
export * from "./CustomerNewPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports